/* eslint-disable no-template-curly-in-string */
import FALLBACK_POLICY from '../fallbackPolicy';
import generateDefaultFlagFromTemplate from '../utils/generateDefaultFlagFromTemplate';

const FEATURE_FLAGS = {
    IS_CAMPAIGN_COMMENT_SECTION_ENABLED: 'is-campaign-comment-section-enabled',
    ONBOARDING_ASSISTANT_ENABLED: 'taboola-ads:onboarding-assistant-enabled',
    SHOULD_REPORT_LOAD_TIME: 'use-i2i-links',
    HAS_OLD_PIXEL: 'has-old-pixel',
    HAS_SWITCHED_TO_TABOOLA_PIXEL: 'has-switched-to-taboola-pixel',
    HAS_CAMPAIGNS: 'has-campaigns',
    HAS_NATIVE_CAMPAIGNS: 'has-native-campaigns',
    HAS_CAMPAIGNS_VIDEO: 'has-campaigns-video',
    CAMPAIGNS_BULK_UPDATE_API_ENABLED_KEY: 'campaigns-bulk-update-api-enabled',
    ONLY_PERFORMANCE_REPORTS: 'backstage:reports:only-performance-reports',
    GOOGLE_DRIVE_EXPORT_ENABLED: 'taboola-ads:reports:google-drive-export-enabled',
    SHOW_CATEGORY_REPORT: 'taboola-ads:reports:categories-reports:is-visible',
    SHOW_CATEGORY_REPORT_MISSING_DATA_INDICATION:
        'taboola-ads:reports:categories-reports:missing-data-indication-is-visible',
    CAN_EDIT_CAMPAIGN_USER_SEGMENTS: 'can-edit-campaign-user-segments',
    CREATIVE_CREATOR_BULK_CREATE_VARIATIONS_ENABLED: 'taboola-ads:creative-creator:bulk-create-variations-enabled',
    MEDIA_LIBRARY_VIDEO_DRAWERS: 'taboola-ads:media-library:video:drawers',
    MEDIA_LIBRARY_IMAGE_DRAWERS: 'taboola-ads:media-library:image:drawers',
    AI_IMAGE_GENERATION_TAB_ENABLED: 'taboola-ads:ai-image-generation-tab-enabled',
    AI_TITLE_SUGGESTIONS_ENABLED: 'taboola-ads:ai-title-suggestions-enabled',
    AI_DESCRIPTION_SUGGESTIONS_ENABLED: 'taboola-ads:ai-description-suggestions-enabled',
    AI_PROMPT_HELPER_ENABLED: 'taboola-ads:ai-prompt-helper-enabled',
    CHAT_AGENT_FIX_WITH_AI_BUTTON_ENABLED: 'taboola-ads:creative-report:chat-agent-fix-with-ai-enabled',
    CHAT_AGENT_FIX_WITH_AI_BUTTON_DESCRIPTION_REJECTION_ENABLED:
        'taboola-ads:creative-report:chat-agent-fix-with-ai-description-rejection-enabled',
    CHAT_AGENT_FIX_WITH_AI_BUTTON_MISMATCHED_REJECTION_ENABLED:
        'taboola-ads:creative-report:chat-agent-fix-with-ai-mismatched-rejection-reason-enabled',
    CHAT_KIT_ENABLED: 'taboola-ads:chat-kit-enabled',
    CHAT_AGENT_BUDGET_RECOMMENDATION_ENABLED: 'taboola-ads:chat-agent-budget-recommendation-enabled',
    APPLE_SECOND_REVIEW_AUTO_APPROVED: 'cra-second-review:apple-second-review-auto-approved',
    ADVERTISER_BYPASS_ENABLED: 'cra:item-tag-blocker:advertiser-bypass:enabled',
    CREATIVE_REPORT_HIDDEN_CRA_TAG_COMMENTS_LIST: 'taboola-ads:creative-report:hidden-cra-tag-comments-list',
    CREATIVE_REPORT_CRA_TAG_TOOLTIP_IGNORE_DSP: 'taboola-ads:creative-report:tags-tooltip-should-ignore-dsp',
    CREATIVE_CREATOR_SHOULD_SHOW_DISPLAY_AD_TYPE: 'taboola-ads:creative-creator:should-show-display-ad-type',
    CREATIVE_CREATOR_SHOULD_SHOW_DIMENSIONS_INFO: 'taboola-ads:creative-creator:should-show-dimensions-info',
    CREATIVES_BULK_ACTIONS_ENABLED: 'taboola-ads:campaigns-reports:creative:is-bulk-actions-enabled',
    CREATIVE_EDIT_VIDEO_DUPLICATE_ENABLED: 'taboola-ads:creative-editor:creative-edit-video-duplicate-enabled',
    CREATIVE_DUPLICATE_ENABLED: 'taboola-ads:campaigns-reports:creative:is-duplicate-enabled',
    REPORT_AUTO_FILTERS: 'taboola-ads:campaigns-reports:auto-filters',
    CREATIVE_FORM_DESCRIPTION_ENABLED: 'taboola-ads:creative-form:description-enabled',
    CREATIVE_FORM_CTA_ENABLED: 'taboola-ads:creative-form:cta-enabled',
    BACKSTAGE_ADVERTISER_ENABLE_CTA: 'backstage:advertiser-enable-cta',
    CTA_TRANSLATIONS_ENABLED: 'taboola-ads:cta-translations-enabled',
    ADS_REPORT_VIDEO_ON_HOVER_ENABLED: 'taboola-ads:ads-reports-video-on-hover-enabled',
    CREATIVE_ONE_BY_ONE_CREATION_ENABLED: 'taboola-ads:creative-creator:one-by-one-creation-enabled',
    ACTION_CONVERSION_VIEWS_LOOKBACK_WINDOW: 'vta:action-conversion-report:include-views-lookback-window',
    ACTION_CONVERSION_CLICK_LOOKBACK_WINDOW: 'action-conversion-report:include-last-click-lookback-window',
    ACTION_CONVERSION_VIEWS_START_DATE: 'vta:action-conversion-report:include-views-start-date',
    ACTION_CONVERSION_LAST_CLICK_START_DATE: 'unip-action-conversion-report:include-last-click-start-date',
    IS_DUPLICATE_CAMPAIGN_SETTINGS_ENABLED: 'taboola-ads:campaigns:is-campaign-duplicate-settings-enabled',
    FEEDBACK_FORM_IS_VISIBLE: 'contact-form-is-enabled',
    CONTACT_SUPPORT_CAN_BE_VISIBLE: 'contact-support-form-can-be-visible',
    AUDIENCE_BULK_ACTION_ENABLED: 'taboola-ads:campaigns-reports:audience:is-bulk-actions-duplicate-enabled',
    USE_COUNTRIES_QUERY: 'taboola-ads:countries-query-enabled',
    IS_BUDGET_LIMIT_RATIO_CONFIG: 'backstage:campaign:enable-spending-limit-multiple-daily',
    BUDGET_LIMIT_RATIO_CONFIG: 'backstage:campaign:enable-spending-limit-multiple-daily-value',
    IS_CREATIVES_AB_TEST_ENABLED: 'backstage:creatives-ab-test:is-enabled',
    CREATIVES_AB_TEST_MIN_END_DATE_DAYS: 'backstage:creatives-ab-test:end-date:min-days-in-test',
    CREATIVES_AB_TEST_MAX_END_DATE_DAYS: 'backstage:creatives-ab-test:end-date:max-days-in-test',
    CREATIVES_AB_TEST_DEFAULT_END_DATE_DAYS: 'backstage:creatives-ab-test:end-date:default-days-in-test',
    LT_MAX_CPC: 'backstage:low-touch-publisher-max-cpc',
    IS_SPECIFIC_LT_MAX_CPC: 'backstage:allow-specific-validation-for-low-touch-publisher-max-cpc',
    IS_MIN_DAY_PARTING_WINDOW: 'backstage:day-parting:minimum-running-window-enable',
    MIN_DAY_PARTING_WINDOW_HRS: 'backstage:day-parting:minimum-running-window-value',
    HEAVY_ACCOUNT: 'backstage:is-heavy-account',
    HEAVY_CREATIVES_REPORT: 'backstage:is-heavy-ads',
    HIDE_HEAVY_ACCOUNT_CREATIVES_REPORT: 'taboola-ads:hide-heavy-account-creatives-reports',
    HIDE_HEAVY_ACCOUNT_CAMPAIGNS_REPORT: 'taboola-ads:hide-heavy-account-campaigns-reports',
    HIDE_HEAVY_ACCOUNT_HIDE_CAMPAIGNS_REPORT_FILTERS: 'taboola-ads:hide-heavy-account-hide-campaigns-report-filters',
    CAMPAIGN_REPORT_TOP_RESULTS_FILTER_ACTIVE: 'taboola-ads:campaign-report-top-result-filter-active',
    SITE_REPORT_TOP_RESULTS_FILTER_ACTIVE: 'taboola-ads:site-report-top-result-filter-active',
    CREATIVE_REPORT_TOP_RESULTS_FILTER_ACTIVE: 'taboola-ads:ads-report-top-result-filter-active',
    ENABLE_EXTERNAL_APPS_PERMISSIONS: 'taboola-ads:external-apps-permissions:enable',
    THIRD_PARTY_CONNECT_ENABLED: 'taboola-ads:third-party-connect-enabled',
    CPC_MIN_VALUE: 'currency:${accountCurrency}:cpc:min-value',
    CPC_MAX_VALUE: 'currency:${accountCurrency}:cpc:max-value',
    VIDEO_RATE_MAX_VALUE: 'currency:${accountCurrency}:video-rate:max-value',
    VIDEO_RATE_MIN_VALUE_CPCV: 'currency:${accountCurrency}:video-rate:min-value-cpcv',
    VIDEO_RATE_MIN_VALUE_CPM: 'currency:${accountCurrency}:video-rate:min-value-cpm',
    VIDEO_RATE_MIN_VALUE_VCPM: 'currency:${accountCurrency}:video-rate:min-value-vcpm',
    CPC_MIN_WARNING: 'currency:${accountCurrency}:cpc:min-warn',
    CPC_MAX_WARNING: 'currency:${accountCurrency}:cpc:max-warn',
    ACCOUNT_CPM_MIN_VALUE: 'currency:${accountCurrency}:cpm:min-value',
    ACCOUNT_CPM_MAX_VALUE: 'currency:${accountCurrency}:cpm:max-value',
    ACCOUNT_CPM_MIN_WARN: 'currency:${accountCurrency}:cpm:min-warn',
    ACCOUNT_CPM_MAX_WARN: 'currency:${accountCurrency}:cpm:max-warn',
    ACCOUNT_VCPM_MIN_VALUE: 'currency:${accountCurrency}:vcpm:min-value',
    ACCOUNT_VCPM_MAX_VALUE: 'currency:${accountCurrency}:vcpm:max-value',
    ACCOUNT_VCPM_MIN_WARN: 'currency:${accountCurrency}:vcpm:min-warn',
    ACCOUNT_VCPM_MAX_WARN: 'currency:${accountCurrency}:vcpm:max-warn',
    ACCOUNT_CPC_DATA_MIN_VALUE: 'currency:${accountCurrency}:cpc:data-min-value',
    ACCOUNT_CPC_DATA_MAX_VALUE: 'currency:${accountCurrency}:cpc:data-max-value',
    ACCOUNT_CPM_DATA_MIN_VALUE: 'currency:${accountCurrency}:cpm:data-min-value',
    ACCOUNT_CPM_DATA_MAX_VALUE: 'currency:${accountCurrency}:cpm:data-max-value',
    ACCOUNT_VCPM_DATA_MIN_VALUE: 'currency:${accountCurrency}:vcpm:data-min-value',
    ACCOUNT_VCPM_DATA_MAX_VALUE: 'currency:${accountCurrency}:vcpm:data-max-value',
    ACCOUNT_BUDGET_LIMITATION_THRESHOLD: 'currency:${accountCurrency}:budgetLimitations:budget-limitation-threshold',
    ACCOUNT_BUDGET_MAX_SPENDING_LIMIT: 'currency:${accountCurrency}:campaignLimit:max-spending-limit',
    ACCOUNT_BUDGET_MIN_SPENDING_LIMIT: 'currency:${accountCurrency}:campaignLimit:min-value',
    LIFETIME_RANGE_PICKER_PRESET_ENABLED: 'taboola-ads:dashboard-range-picker:dynamic-presets:lifetime-enabled',
    PIXEL_PREDICTIVE_ENABLED: 'taboola-ads:pixel-based-predictive:enabled',
    ENABLE_GROUP_LEADS_GENERATION: 'campaigns-group:leads-generation:enable',
    ENABLE_GROUP_ONLINE_PURCHASES: 'campaigns-group:online-purchases:enable',
    ENABLE_GROUP_DRIVE_WEBSITE_TRAFFIC: 'campaigns-group:drive-website-traffic:enable',
    ENABLE_GROUP_BRAND_AWARENESS: 'campaigns-group:brand-awareness:enable',
    ENABLE_GROUP_MOBILE_APP_INSTALL: 'campaigns-group:mobile-app-install:enable',
    TAG_TYPE_IAS_ENABLED: 'taboola-ads:campaign-3rd-party-tags-ias:enabled',
    TAG_TYPE_ADLOOX_ENABLED: 'taboola-ads:campaign-3rd-party-tags-adloox:enabled',
    TAG_TYPE_DV_ENABLED: 'taboola-ads:campaign-3rd-party-tags-dv:enabled',
    TAG_TYPE_GOOGLE_DCM_ENABLED: 'taboola-ads:campaign-3rd-party-tags-google-dcm:enabled',
    TAG_TYPE_IMAGE_PIXEL_ENABLED: 'taboola-ads:campaign-3rd-party-tags-image-pixel:enabled',
    PROGRAMMATIC_BUDGET_ENABLED: 'taboola-ads:campaign-form:programmatic-budget-enabled',
    SHOULD_DISPLAY_LEGACY_CATEGORY_FILTER: 'taboola-ads:campaign-report:should-display-legacy-category-filter',
    SHOULD_DISPLAY_IAB_CATEGORY_FILTER: 'taboola-ads:campaign-report:should-display-iab-category-filter',
    ENABLE_DEAL_ID: 'backstage:enable-deal-id-field',
    IMPRESSION_TYPE_FIELD: 'backstage:impression-type-field',
    CREATE_LOOKALIKE_ALLOWED: 'taboola-ads:create-lookalike-allowed',
    CREATE_LOOKALIKE_ALLOWED_NEW: 'taboola-ads:create-lookalike-allowed-new',
    ADS_CONSOLE_CUSTOM_CONTEXTUAL_ALLOWED: 'taboola-ads:custom-contextual-allowed',
    ADS_CONSOLE_COMBINED_AUDIENCES_ALLOWED: 'taboola-ads:combined-audiences-allowed',
    ADS_CONSOLE_YAHOO_AUDIENCES_ALLOWED: 'taboola-ads:yahoo-audiences-allowed',
    ADS_CONSOLE_YAHOO_AUDIENCES_KEYWORD_SUGGESTIONS_ALLOWED: 'taboola-ads:yahoo-audiences-keyword-suggestions-allowed',
    ADS_CONSOLE_YAHOO_AUDIENCES_SUGGESTIONS_AND_CATEGORIES_ALLOWED:
        'taboola-ads:yahoo-audiences-suggestions-and-categories-allowed',
    ADS_CONSOLE_REACH_ESTIMATOR_ALLOWED: 'taboola-ads:reach-estimator-allowed',
    ADS_CONSOLE_REACH_ESTIMATOR_BID_ALLOWED: 'reach-estimator:is-bid-allowed-for-publisher',
    ADS_CONSOLE_CUSTOM_CONTEXTUAL_ARTICLES_PREVIEW_ALLOWED: 'taboola-ads:custom-contextual-articles-preview-allowed',
    CREATE_CUSTOMER_FILE_ALLOWED: 'taboola-ads:create-customer-file-allowed',
    TARGET_CPA_ENABLED: 'backstage:target-cpa:is-enabled',
    TARGET_CPA_NO_CPC_ENABLED: 'backstage:target-cpa-no-cpc:is-enabled',
    TARGET_CPA_DUPLICATE_CAMPAIGN_ENABLED: 'backstage:target-cpa-duplicate-campaign:is-enabled',
    MAX_VALUE_ENABLED: 'taboola-ads:max-value:is-enabled',
    TARGET_ROAS_ENABLED: 'taboola-ads:target-roas:is-enabled',
    MAX_CONVERSIONS_CPC_CAP_ENABLED_FOR_PUBLISHER: 'max-conversions:should-use-max-cpc',
    TARGET_CPA_ELIGIBLE_ACCOUNTS: 'target-cpa:target-cpa-eligible-accounts',
    SUPPLY_EXPLORATION_ENABLED: 'supply-exploration:is-enabled',
    SAFETY_NETS_ENABLED_CONFIG_ATTRIBUTE: 'safety-nets:enabled',
    FREQUENCY_CAPPING_ENABLED_CONFIG_ATTRIBUTE: 'frequency-capping:enabled',
    CAMPAIGN_LEVEL_CONVERSIONS_BID_STRATEGY_ALLOW_TARGET_CPA:
        'campaign-level-conversions:bid-strategy:allow-target-cpa',
    CAMPAIGN_LEVEL_CONVERSIONS_BID_STRATEGY_ALLOW_MAX_CONVERSIONS:
        'campaign-level-conversions:bid-strategy:allow-max-conversions',
    ENABLE_CREATIVE_TRACKING: 'taboola-ads:creative-form:tracking',
    HYBRID_MODULE_QUERY_PARAMS_ENABLED: 'taboola-ads:hybrid-module-query-params-enabled',
    HYBRID_MODULE_HEADER_PARAMS_ENABLED: 'taboola-ads:hybrid-module-header-params-enabled',
    IS_DCO_ACCOUNT: 'has-dco-ecomm-columns',
    BILLING_AND_PAYMENTS_MODULE_ENABLED: 'taboola-ads:billing-and-payments-module-enabled',
    SHOULD_HIDE_CURRENT_BALANCE: 'taboola-ads:should-hide-current-balance',
    CREATIVE_RESUBMISSION_ENABLED: 'resubmit-creatives:is-enabled',
    BLOCK_INSIGNICANT_CREATIVE_CHANGES_ENABLED: 'block-insignificant-creative-changes-enabled',
    MIN_CONVERSIONS_GOAL_ENABLED: 'backstage:target-cpa:min-conversion-goal:is-enabled',
    NOTIFICATIONS_CENTER_ENABLED: 'taboola-ads:notifications-center-enabled',
    NOTIFICATIONS_CENTER_ONLY_FOR_LOW_TOUCH: 'taboola-ads:notifications-center:enabled-for-low-touch-only',
    SHOW_OUTDATED_API_NOTICE: 'taboola-ads:show-outdated-api-notice',
    MY_AUDIENCE_DROPDOWN_IS_DISABLEABLE: 'taboola-ads:my-audience-dropdown:is-disableable',
    MY_AUDIENCES_FILTERS_ENABLED: 'taboola-ads:my-audiences-filters-enabled',
    WOCHIT_CREATE_VIDEO_ENABLED: 'taboola-ads:wochit-create-video-enabled',
    SHOW_CAMPAIGN_HISTORY_REPORT: 'taboola-ads:show-campaign-history-report',
    SHOW_CAMPAIGN_HISTORY_REPORT_GRAPH: 'taboola-ads:show-campaign-history-report-graph',
    SHOW_COMPARE_CAMPAIGNS_GRAPH: 'taboola-ads:show-compare-campaigns-graph',
    SHOW_COMPARE_CREATIVES_GRAPH: 'taboola-ads:show-compare-creatives-graph',
    ENABLE_RIBBON_RECOMMENDATION: 'performance:recommendation:enable-ribbon-recommendation',
    SUBMISSION_DATA_ALLOWED_IN_ADS_REPORT: 'submission-data:allowed-in-creatives-report',
    AUDIENCE_TARGETING_FIRST_CAMPAIGN_MESSAGE_ENABLED: 'taboola-ads:audience-targeting-first-campaign-message-enabled',
    IS_WITH_TAX_REGISTRATION: 'taboola-ads:is-with-tax-registration',
    IS_WITH_VAT_ID: 'taboola-ads:is-with-vat-id',
    CAMPAIGN_LEVEL_CONVERSIONS: 'campaign-level-conversions:is-enabled-ta',
    TA_REALTIME: 'taboola-ads:is-realtime-enabled',
    AUTO_REVIEWER_CONTENT_VALIDATIONS_ENABLED: 'taboola-ads:auto-reviewer-content-validation-is-enabled',
    AUTO_REVIEWER_CROPPED_IMAGE_SAFETY_VALIDATIONS_ENABLED:
        'taboola-ads:auto-reviewer-cropped-image-safety-validation-is-enabled',
    IS_SCHEDULE_TRACKING_EXPERT_ENABLED_TA: 'taboola-ads:tracking:is-schedule-tracking-expert-enabled',
    IS_PIXEL_CODE_ENABLED: 'backstage:send-pixel-code-is-enabled',
    TRACKING_SCREENS: 'taboola-ads:tracking-screens',
    GTM_AUTOMATED_SETUP_ENABLED: 'taboola-ads:tracking:gtm-automated-setup-enabled',
    CONVERSION_AGGREGATED_TYPE_ENABLED: 'taboola-ads:tracking:aggregated-type-enabled',
    CONVERSION_FUNNEL_ENABLED: 'taboola-ads:tracking:conversion-funnel-enabled',
    CONVERSION_DEFAULT_FUNNEL_ENABLED: 'taboola-ads:tracking:conversion-default-funnel-enabled',
    CAMPAIGN_PERFORMANCE_RULES_ENABLED: 'taboola-ads:campaign-performance-rules-enabled',
    PERFORMANCE_RULES_ENABLED: 'taboola-ads:performance-rules-enabled',
    PERFORMANCE_RULES_EXECUTED_ACTIONS_ENABLED: 'taboola-ads:performance-rules-executed-actions-enabled',
    EDIT_PERFORMANCE_RULES_ENABLED: 'taboola-ads:edit-performance-rules-enabled',
    DUPLICATE_PERFORMANCE_RULES_ENABLED: 'taboola-ads:duplicate-performance-rules-enabled',
    PERFORMANCE_RULES_PREVIEW_ENABLED: 'taboola-ads:performance-rules-preview-enabled',
    PERFORMANCE_RULES_REPORTS_ENABLED: 'performance-rules-reports-enabled',
    PERFORMANCE_RULES_LONG_LOOK_BACK_WINDOW_ENABLED: 'taboola-ads:performance-rules-long-look-back-window-enabled',
    PERFORMANCE_RULES_UNDO_ACTIONS_ENABLED: 'taboola-ads:performance-rules-undo-actions-enabled',
    PERFORMANCE_RULES_ENABLE_EMAIL_NOTIFICATIONS: 'taboola-ads:performance-rules-enable-email-notifications',
    PERFORMANCE_RULES_ENABLE_CAMPAIGN_DIMENSION: 'taboola-ads:performance-rules-enable-campaign-dimension',
    PERFORMANCE_RULES_ENABLE_LEAVE_AN_ACTIVE_ITEM: 'taboola-ads:performance-rules-enable-leave-an-active-item',
    PERFORMANCE_RULES_TIME_WINDOW_OFFSET_ENABLED: 'taboola-ads:performance-rules-time-window-offset-enabled',
    CVR_LEARNING_STATUS_ENABLED: 'taboola-ads:cvr-learning-status:enabled',
    DCO_ACCOUNT_HAS_IN_TRIAL_CAMPAIGNS: 'taboola-ads:dco-publisher-has-in-trial-campaigns',
    CROPPING_IMAGE_ENABLED: 'taboola-ads:cropping-image-enable',
    OUTCROPPING_IMAGE_ENABLED: 'taboola-ads:outcropping-image-enabled',
    RANGE_OF_RATIO_OUTCROPPING_ENABLED: 'taboola-ads:range-of-ratio-outcropping-enabled',
    CREATIVE_REPORT_USE_WIDE_CONFIG_MSV2: 'taboola-ads:use-wide-performance-table-in-creatives-report',
    CREATIVE_VIDEO_NEW_FORM_ACCOUNT: 'backstage:video:new-creative-form',
    MARKETPLACE_AUDIENCES_BUNDLING_ENABLED: 'taboola-ads:marketplace-audiences-bundling-enable',
    DEMOGRAPHICS_AUDIENCES_REPORT_ENABLED: 'taboola-ads:demographics-audiences-report-enable',
    MARKETPLACE_AUDIENCES_AND_LOGIC_ENABLED: 'backstage:marketplace-audiences-multiple-targetings:enabled',
    MARKETPLACE_AUDIENCES_AGE_GROUP_IDS_LIST: 'backstage:marketplace-audiences:age-segments-ids:list',
    MARKETPLACE_AUDIENCES_GENDER_GROUP_IDS_LIST: 'backstage:marketplace-audiences:gender-segments-ids:list',
    MARKETPLACE_AUDIENCES_AGE_GROUP_TAXONOMY_PARENTS_LIST:
        'backstage:marketplace-audiences:age-segments-parents-ids:list',
    MARKETPLACE_AUDIENCES_GENDER_GROUP_TAXONOMY_PARENTS_LIST:
        'backstage:marketplace-audiences:gender-segments-parents-ids:list',
    MARKETPLACE_AUDIENCES_AGE_SEGMENT_LIMIT: 'backstage:marketplace-audiences:age-segment:limit',
    MARKETPLACE_AUDIENCES_GENDER_SEGMENT_LIMIT: 'backstage:marketplace-audiences:gender-segment:limit',
    MARKETPLACE_AUDIENCES_MIXED_SEGMENT_LIMIT: 'backstage:marketplace-audiences:mixed-segment:limit',
    MARKETPLACE_AUDIENCES_ADVANCED_SEARCH_ENABLED: 'taboola-ads:marketplace-audiences-advanced-search-enabled',
    BID_STRATEGY_V2_ENABLED: 'taboola-ads:bid-strategy-v2:enabled',
    MAX_CONVERSIONS_ENABLED: 'backstage:max-conversions:is-enabled',
    CREATIVE_CREATION_AI_VARIATIONS_ENABLED: 'taboola-ads:creative-creation-ai-variations-enabled',
    CAMPAIGN_MULTIPLE_CONVERSIONS_ENABLED: 'campaign-level-conversions:multiple-unip-rules-enabled',
    CAMPAIGN_NON_OPTIMIZED_CONVERSIONS_ENABLED: 'non-optimized-campaign-level-conversions:is-enabled',
    HIDE_CONVERSIONS_GOAL_ACCOUNT_DEFAULT: 'taboola-ads:hide-conversion-goal-account-default',
    CAMPAIGN_GROUP_ENABLED: 'backstage:campaign-group:is-using-campaign-group',
    CAMPAIGN_GROUP_EXTENSION_ENABLED: 'backstage:campaign-group:is-skip-override-fields-for-campaign-group',
    CAMPAIGN_GROUP_IS_MANDATORY: 'backstage:campaign-group:is-campaign-group-mandatory',
    CAMPAIGN_GROUP_BUDGET_DISTRIBUTION_ENABLED: 'backstage:campaign-group:budget-distribution:enabled',
    PACE_AHEAD_ENABLED: 'backstage:pace-ahead:is-enabled',
    CAMPAIGN_GROUP_PACE_AHEAD_ENABLED: 'backstage:campaign-group-pace-ahead:is-enabled',
    BID_DAY_TIME_ENABLED: 'taboola-ads:day-time-bid-enabled',
    TIME_ZONE_ENABLED: 'taboola-ads:time-zone-enabled',
    USER_TIME_ZONE_ENABLED: 'taboola-ads:user-time-zone-enabled',
    SCHEDULE_DAY_TIME_ENABLED: 'day-time-schedule-enabled',
    BID_PLATFORM_ENABLED: 'taboola-ads:bid-mods-platform-enabled',
    CAMPAIGN_CONVERSION_CONFIGURATION_ENABLED: 'taboola-ads:campaign:campaign-conversion-configuration-enabled',
    MAX_EXCLUDE_COUNTRIES: 'taboola-ads:campaign-targeting:max-exclude-countries-allowed',
    AI_WIZARD_ONBOARDING: 'taboola-ads:ai-wizard-onboarding',
    CAMPAIGN_REPORT_USE_WIDE_CONFIG_MSV2: 'taboola-ads:use-wide-performance-table-in-campaign-report',
    SITE_REPORT_USE_WIDE_CONFIG_MSV2: 'taboola-ads:use-wide-performance-table-in-site-report',
    SITE_REPORT_DONT_USE_WIDE_CONFIG_MSV2: 'taboola-ads:dont-use-wide-performance-table-in-site-report',
    FAVORITED_MEDIA_ENABLED: 'taboola-ads:favorited-media-enabled',
    SUPPLY_TARGETING_ENABLED: 'taboola-ads:supply-targeting-enabled',
    SUPPLY_TARGETING_SLIDER_ENABLED: 'taboola-ads:supply-targeting-slider-enabled',
    REACH_ESTIMATOR_SUPPLY_TARGETING_AND_SITE_TARGETING_WARNING:
        'taboola-ads:reach-estimator:supply-targeting-and-site-targeting-warning',
    SUPPLY_TARGETING_USE_TABOOLA_VALUE_AS_DEFAULT: 'taboola-ads:supply-targeting-use-taboola-value-as-default',
    SUPPLY_TARGETING_USE_YAHOO_MOMENTS_SLIDER_ENABLED: 'taboola-ads:supply-targeting-use-yahoo-moments-slider-enabled',
    SUPPLY_TARGETING_PMP_ENABLED: 'taboola-ads:supply-targeting-pmp-enabled',
    LOW_TIER_DAILY_LIMIT_MAX_VALUE: 'backstage:low-tier:campaign:daily-limit',
    TA_PIXEL_WARNINGS_TESTING: 'taboola-ads:pixel-warnings-testing',
    PROFIT_MARGIN_ENABLED: 'profit-margin-enabled',
    SHOULD_DISPLAY_JS_FOR_ALL: 'taboola-ads:should-display-js-for-all',
    DISABLED_CLC_THRESHOLD_WARNING: 'taboola-ads:disabled-clc-threshold-warning',
    REPLACE_IMAGE_BACKGROUND: 'taboola-ads:replace-image-background-enabled',
    REPLACE_IMAGE_BACKGROUND_SEGMENT_ANYTHING:
        'taboola-ads:replace-image-background-segment-anything-foreground-detection-enabled',
    REPLACE_IMAGE_BACKGROUND_SEGMENT_ANYTHING_POPUP:
        'taboola-ads:replace-image-background-segment-anything-foreground-detection-popup-enabled',
    CREATIVE_STUDIO_GENERATE_VARIATIONS: 'taboola-ads:creative-studio:generate-variations-enabled',
    GEN_AI_EDIT_DUPLICATE_TOOLTIP_ENABLED: 'taboola-ads:creative-studio:edit-duplicate-tooltip-enabled',
    SUPPORT_APP_INSTALL_MULTI_SLOTS_WIDGETS: 'taboola-ads:support-app-install-multi-slots-widgets',
    AI_VARIATIONS_REPLACEMENT_ENABLED: 'taboola-ads:ai-variations-replacement-enabled',
    ACCOUNT_REPORT_ENABLED: 'taboola-ads:account-report-enabled',
    ONLINE_PURCHASES_MARKETING_OBJECTIVE_ENABLED: 'taboola-ads:online-purchases-marketing-objective-enabled',
    SHOW_CAMPAIGN_GROUP_PICKER_IN_IFRAME: 'taboola-ads:show-campaign-group-picker-in-iframe',
    CAMPAIGN_BULK_UPLOAD: 'taboola-ads:campaign-bulk-upload-enabled',
    BULK_OPERATIONS_METADATA_CHECK_DISABLED: 'taboola-ads:bulk-operations-metadata-check-disabled',
    ALLOW_SEARCH_ADS_REPORTS: 'allow-search-ads-reports-ui-test',
    CREATIVE_CAROUSEL_ENABLED: 'taboola-ads:creative-carousel-enabled',
    IS_VERTICAL_CREATIVE_ENABLED: 'taboola-ads:is-vertical-creative-enabled',
    UNIFIED_CREATIVE_ENDPOINTS_ENABLED: 'taboola-ads:unified-creative-endpoints-enabled',
    GEN_AI_AB_TEST_WITH_AI: 'taboola-ads:gen-ai-ab-test-with-ai',
    GEN_AI_OPTIMIZATION_PREVIEWS_DRAWER_ENABLED: 'taboola-ads:gen-ai-optimization-previews-drawer-enabled',
    LLM_DKI_DETECTION_ENABLED: 'taboola-ads:creatives:llm-dki-detection-enabled',
    UNLIMITED_BUDGET_ENABLED: 'taboola-ads:unlimited-budget-enabled',
    SHOW_LEGACY_CATEGORY_FILTER: 'show-legacy-category-filter',
    IS_BILLING_RECONCILIATION_V2_ENABLED: 'billing:reconciliation-v2:is-enabled',
    ENABLE_READ_FOR_STRIPE_CARD_3DS: 'billing:new-model:enable-read-for-stripe-card-3ds',
    SHOW_INTERNAL_LINK_CUSTOM_CONTEXT_MENU: 'taboola-ads:show-internal-link-custom-context-menu',
    DROPDOWN_EDIT_FALLBACK_IMAGE_OPTION_ENABLED: 'taboola-ads:dropdown-edit-fallback-image-option-enabled',
    SHOW_CUSTOM_DATA_IN_CREATIVE_FORM: 'taboola-ads:show-custom-data-in-creative-form',
    SHOULD_SHOW_DISPLAY_DATA: 'taboola-ads:should-show-display-data-in-report',
    ACCOUNT_MANAGEMENT_ENABLED: 'taboola-ads:account-management-enabled',
    REALIZE_HOME_ENABLED: 'taboola-ads:realize-home-enabled',
    CAMPAIGN_EXTERNAL_METADATA_ENABLED: 'taboola-ads:campaign-external-metadata-enabled',
    BULK_URL_VALIDATION_ENABLED: 'taboola-ads:bulk-url-validation-is-enabled',
    HIDE_ADMIN_ACCOUNT_SITE_REPORT: 'taboola-ads:hide-admin-account-site-reports',
    SHOW_PO_NUMBER: 'taboola-ads:show-po-number',
    CREATIVE_FORM_LOGO_FIELD_ENABLED: 'taboola-ads:creative-form-logo-field-enabled',
    EXTERNAL_DATA_DELETION_DISABLED: 'backstage:external-data:deletion-disabled',
    EXTERNAL_DATA_READONLY_FIELDS: 'backstage:external-data:account:read-only-fields',
    CAMPAIGN_EXTERNAL_DATA_DELETION_DISABLED: 'backstage:campaign-external-data:deletion-disabled',
    CAMPAIGN_EXTERNAL_DATA_READONLY_FIELDS: 'backstage:campaign-external-data:read-only-fields',
    SCHEDULED_REPORTS_VIEW: 'taboola-ads:scheduled-reports-view:enable',
    SCHEDULED_REPORTS_EDIT: 'taboola-ads:scheduled-reports-edit:enable',
    SCHEDULED_REPORTS_EDIT_VIEW_ON_NETWORK: 'taboola-ads:scheduled-reports-on-network:enabled',
    SCHEDULED_REPORTS_ACCOUNT_SELECT_ON_NETWORK_LEVEL:
        'taboola-ads:scheduled-reports-select-account-enabled-for-networks:enable',
    SCHEDULED_REPORTS_CAMPAIGN_GROUP_REPORT_ENABLED:
        'taboola-ads:scheduled-reports-campaign-group-report:enabled-for-dsp',
    SCHEDULED_REPORTS_CUSTOM_RULE_REPORT_ENABLED: 'taboola-ads:scheduled-reports-custom-rule-report:enabled',
    SCHEDULED_REPORTS_CAMPAIGN_AGENCY_REPORT_ENABLED: 'taboola-ads:scheduled-reports-campaign-agency-report:enabled',
    PROFIT_MARGIN_IN_REPORT_ENABLED: 'taboola-ads:profit-margin-in-report-enabled',
    VTA_LOOKBACK_WINDOW_INITIAL_VALUE_IN_HOURS: 'vta:lookback-window-initial-value-in-hours',
    VTA_LOOKBACK_WINDOW_MAX_VALUE_IN_HOURS: 'vta:lookback-window-max-value-in-hours',
    VTA_LOOKBACK_WINDOW_DEFAULT_VALUE_IN_DAYS: 'vta:lookback-window-max-value-in-days',
    VTA_LOOKBACK_WINDOW_CHECKBOX_ENABLED: 'vta:lookback-window-checkbox-enabled',
    TABOOLA_SELECT_ENABLED: 'taboola-ads:taboola-select-enabled',
    TABOOLA_SELECT_ENABLED_FOR_VIDEO_ACCOUNT: 'taboola-ads:taboola-select-enabled-for-video-account',
    SUPPORT_BP_ASPECT_RATIOS: 'taboola-ads:support-bp-aspect-ratios',
    EXCEL_BULK_ALLOW_FULL_CONFIG: 'taboola-ads:excel-bulk-allow-full-config',
    VENDOR_MACRO_REPLACEMENT_ENABLED: 'taboola-ads:vendor-macro-replacement-enabled',
    SHOW_ESTIMATED_DAILY_CAP_COLUMN_REPORTS: 'show-estimated-daily-cap-column-reports',
    ENABLE_YAHOO_APP_HEADER_STYLE: 'taboola-ads:enable-yahoo-app-header-style',
    VIDEO_CREATIVE_UPLOADER_IS_VERTICAL_VIDEO_ALLOWED: 'taboola-ads:video-creative-uploader-is-vertical-video-allowed',
    CHAT_AGENT_ONBOARDING_ENABLED: 'taboola-ads:chat-agent-onboarding-enabled',
    ONBOARDING_JOURNEY_ENABLED: 'taboola-ads:onboarding-journey-enabled',
    MULTI_LAYER_DRAWER_ENABLED: 'taboola-ads:multi-layer-drawer-enabled',
    IS_TCPA_PIXEL_VALIDATION_ENABLED: 'backstage:target-cpa:is-pixel-validation-enabled',
    PERFORMANCE_RULES_ENABLE_EXCLUDE_NEW_CAMPAIGNS: 'taboola-ads:performance-rules:enable-exclude-new-campaigns',
    SHOW_SHOPIFY_SETUP: 'taboola-ads:show-shopify-setup',
    SENSITIVE_TOPICS_BRAND_SAFETY_ENABLED: 'taboola-ads:brand-safety:sensitive-topics-enabled',
    CAMPAIGNS_GROUP_BULK_ACTIONS_ENABLED: 'taboola-ads:campaigns-reports:campaigns-group:is-bulk-actions-enabled',
    DISABLE_CREATE_BUTTON: 'taboola-ads:disable-create-button',
    EXCEL_BULK_UPLOAD_ADS_ONLY: 'taboola-ads:excel-bulk-upload-ads-only',
    THUMBNAIL_TRANSFORMATION_PADDING: 'recommendation-unit:thumbnail-transformations',
    BID_MODIFICATION_DAY_TIME_BOOST_MAX_DEFAULT: 'day-time-bid-manager:max-multiplier-val',
    CAMPAIGN_SIMULATOR_ENABLED: 'taboola-ads:is-campaign-simulator-enabled',
    CAMPAIGN_SIMULATOR_CHECK_PERMISSION_ENABLED: 'taboola-ads:is-campaign-simulator-check-permission-enabled',
    CAMPAIGN_SIMULATOR_BUTTON_ENABLED: 'taboola-ads:campaign-simulator-button-enabled',
    CAMPAIGN_SIMULATOR_WEEKLY_ENABLED: 'taboola-ads:campaign-simulator-weekly-enabled',
    CAMPAIGN_SIMULATOR_BOUNDS_VISUALIZATION_ENABLED: 'taboola-ads:campaign-simulator-bounds-visualization-enabled',
    CAMPAIGN_BULK_EDIT_ENABLED: 'taboola-ads:campaign-bulk-edit-enabled',
    ENGAGEMENT_CREATE_ENABLED: 'taboola-ads:engagement-create-enabled',
    SCROLL_DEPTH_ENABLED: 'taboola-ads:scroll-depth-enabled',
    DISPLAY_ITEM_ENABLED: 'taboola-ads:display-item-enabled',
    IS_DISPLAY_FILTERS_ENABLED: 'taboola-ads:is-display-filters-enabled',
    DYNAMIC_REPORTS_ENABLED: 'taboola-ads:dynamic-reports-enabled',
    MAX_TOTAL_RECORDS_FOR_REPORT_EXPORT: 'taboola-ads:max-allowed-records-for-report-export',
    MAX_TOTAL_RECORDS_FOR_DYNAMIC_REPORT_EXPORT: 'taboola-ads:max-allowed-records-for-dynamic-report-export',
    DYNAMIC_REPORTS_TODAY_PRESET_ENABLED: 'taboola-ads:dynamic-reports-today-preset-enabled',
    CODELESS_CONVERSIONS_ENABLED: 'taboola-ads:codeless-conversions-enabled',
    PIXEL_TESTER_ENABLED: 'taboola-ads:pixel-tester-enabled',
    PIXEL_TESTER_S2S_ENABLED: 'taboola-ads:pixel-tester-s2s-enabled',
    PIXEL_TESTER_USER_MATCHING_ENABLED: 'taboola-ads:pixel-tester-user-matching-enabled',
    DISPLAY_IMPORT_FROM_SOCIAL_ENABLED: 'taboola-ads:display-import-from-social-enabled',
    IS_DISPLAY_AD_TAG_SERVICE_ENABLED: 'backstage:third-party-tag:is-display-ad-tag-enabled',
    CAMPAIGN_GROUP_PICKER_ENABLED: 'taboola-ads:campaign-group-picker-enabled',
    CODELESS_TFA_VALIDATION_ENABLED: 'taboola-ads:codeless-tfa-validation-enabled',
    CODELESS_VALUE_ENABLED: 'taboola-ads:codeless-value-enabled',
    CODELESS_LOG_ROCKET_ENABLED: 'taboola-ads:codeless:log-rocket',
    CAMPAIGN_GROUP_DUPLICATE_ENABLED: 'taboola-ads:campaign-group-duplicate-enabled',
    CREATE_PBP_EXCLUDED_CUSTOMER_PROFILES_LIST: 'backstage:pixel-based-predictive:excluded-customer-profiles-set',
    NEW_EXPORT: 'taboola-ads:new-export-enabled',
    DYNAMIC_REPORT_ASYNC_EXPORT: 'taboola-ads:dynamic-report-new-export-enabled',
    ADS_CONSOLE_BLOCK_PREDICTIVE_AUDIENCES_IN_EDIT_CAMPAIGN:
        'taboola-ads:ads-console-block-predictive-audiences-in-edit-campaign',
    ADS_CONSOLE_PREVENT_PBP_NON_PBP_AUDIENCE_TYPE_MIXING_IN_EDIT_CAMPAIGN:
        'taboola-ads:ads-console-prevent-pbp-non-pbp-audience-type-mixing-in-edit-campaign',
    CREATE_IMAGE_TO_MOTION_ENABLED: 'taboola-ads:create-image-to-motion-enabled',
    IMAGE_TO_MOTION_PARAMS_ENABLED: 'taboola-ads:image-to-motion-params-enabled',
    ENABLE_CREATIVE_BULK_EDIT_AD_SCHEDULE: 'taboola-ads:enable-creative-bulk-edit-ad-schedule',
    DYNAMIC_REPORTS_METAMODEL_EXCLUDE_NODE_LIST: 'ads-console:dynamic-reports:exclude-node-list',
    CREATIVE_LIBRARY_ENABLED: 'taboola-ads:creative-library-enabled',
    CREATIVE_LIBRARY_BULK_EXCEL_ENABLED: 'taboola-ads:creative-library-bulk-excel-enabled',
    INVENTORY_TYPE_TARGETING_ENABLED: 'taboola-ads:inventory-type-targeting-enabled',
    GEN_AI_LANDING_PAGES_MODULE_ENABLED: 'taboola-ads:gen-ai-landing-pages-module-enabled',
    CAROUSEL_ALLOW_HIERARCHY_FALLBACK: 'taboola-ads:carousel-allow-hierarchy-fallback',
    COUPLE_REPORT_UI_AND_BACKEND_TRACE: 'taboola-ads:couple-report-ui-backend-trace',
    AUDIENCE_LAST_REFRESHED_ENABLED: 'taboola-ads:is-audience-last-refreshed-enabled',
    DUPLICATE_CAMPAIGNS_COPIES_FIELD_ENABLED: 'taboola-ads:duplicate-campaigns-copies-field-enabled',
    CHANGE_CAMPAIGN_GROUP_START_DATE_ENABLED: 'campaign-group:is-change-campaign-group-start-date-enabled',
    CODELESS_CONTINUE_ANYWAY_ENABLED: 'taboola-ads:codeless-tfa-validation-continue-anyway-enabled',
    ADS_CONSOLE_CAMPAIGN_GROUP_GOAL_ROLLOUT: 'taboola-ads:ads-console--campaign-group-goal-rollout',
    EVENT_MANAGER_ENABLED: 'taboola-ads:event-manager-enabled',
    SHOULD_STOP_USING_REPORT_HISTORICAL_DATA: 'taboola-ads:should-stop-using-report-historical-data',
    MAX_DATE_RANGE_LENGTH_MONTH: 'backstage:dynamic-reports:max-date-range',
    IS_MANDATORY_HIERARCHY_ENABLED: 'backstage:campaign-group:is-mandatory-hierarchy-enabled',
    CAMPAIGN_GROUP_BUDGET_UNLIMITED_AS_NONE_ENABLED: 'backstage:campaign-group:budget-unlimited-as-none:enabled',
    BID_MODIFIER_BULK_EDIT_ENABLED: 'taboola-ads:bid-modifier-bulk-edit-enabled',
    BULK_EDIT_UNSAVED_CHANGES_ENABLED: 'taboola-ads:bulk-edit-unsaved-changes-enabled',
    IS_DEFAULT_TRACKING_CODE_EMPTY: 'is-default-tracking-code-empty',
    IS_BID_MODIFICATION_ON_VIDEO_SITE_REPORT_ENABLED: 'taboola-ads:is-bid-modification-on-video-site-report-enabled',
};

const fallbackPolicies = {
    ONLY_PERFORMANCE_REPORTS: FALLBACK_POLICY.PUBLISHER_ONLY,
    BACKSTAGE_ADVERTISER_ENABLE_CTA: FALLBACK_POLICY.FULL,
    HEAVY_ACCOUNT: FALLBACK_POLICY.PUBLISHER_ONLY,
    HEAVY_CREATIVES_REPORT: FALLBACK_POLICY.PUBLISHER_ONLY,
    HIDE_HEAVY_ACCOUNT_CREATIVES_REPORT: FALLBACK_POLICY.PUBLISHER_ONLY,
    HIDE_HEAVY_ACCOUNT_CAMPAIGNS_REPORT: FALLBACK_POLICY.PUBLISHER_ONLY,
    HIDE_HEAVY_ACCOUNT_HIDE_CAMPAIGNS_REPORT_FILTERS: FALLBACK_POLICY.PUBLISHER_ONLY,
    SITE_REPORT_DONT_USE_WIDE_CONFIG_MSV2: FALLBACK_POLICY.PUBLISHER_AND_GLOBAL,
    DISABLE_CREATE_BUTTON: FALLBACK_POLICY.PUBLISHER_ONLY,
    MAX_TOTAL_RECORDS_FOR_REPORT_EXPORT: FALLBACK_POLICY.FULL,
};

const configKeyData = {
    [FEATURE_FLAGS.CPC_MIN_VALUE]: [
        {
            accountCurrency: 'USD',
            defaultValue: 0.01,
        },
    ],
    [FEATURE_FLAGS.CPC_MAX_VALUE]: [
        {
            accountCurrency: 'USD',
            defaultValue: Number.POSITIVE_INFINITY,
        },
    ],
    [FEATURE_FLAGS.VIDEO_RATE_MAX_VALUE]: [
        {
            accountCurrency: 'USD',
            defaultValue: 70,
        },
    ],
    [FEATURE_FLAGS.VIDEO_RATE_MIN_VALUE_CPCV]: [
        {
            accountCurrency: 'USD',
            defaultValue: 0.005,
        },
    ],
    [FEATURE_FLAGS.VIDEO_RATE_MIN_VALUE_CPM]: [
        {
            accountCurrency: 'USD',
            defaultValue: 1,
        },
    ],
    [FEATURE_FLAGS.VIDEO_RATE_MIN_VALUE_VCPM]: [
        {
            accountCurrency: 'USD',
            defaultValue: 1.5,
        },
    ],
    [FEATURE_FLAGS.CPC_MAX_WARNING]: [
        {
            accountCurrency: 'USD',
            defaultValue: Number.POSITIVE_INFINITY,
        },
    ],
    [FEATURE_FLAGS.CPC_MIN_WARNING]: [
        {
            accountCurrency: 'USD',
            defaultValue: 0,
        },
    ],
    [FEATURE_FLAGS.ACCOUNT_CPM_MIN_VALUE]: [
        {
            accountCurrency: 'USD',
            defaultValue: 0.01,
        },
    ],
    [FEATURE_FLAGS.ACCOUNT_CPM_MAX_VALUE]: [
        {
            accountCurrency: 'USD',
            defaultValue: 30,
        },
    ],
    [FEATURE_FLAGS.ACCOUNT_CPM_MIN_WARN]: [
        {
            accountCurrency: 'USD',
            defaultValue: 0.05,
        },
    ],
    [FEATURE_FLAGS.ACCOUNT_CPM_MAX_WARN]: [
        {
            accountCurrency: 'USD',
            defaultValue: 15,
        },
    ],
    [FEATURE_FLAGS.ACCOUNT_VCPM_MIN_VALUE]: [
        {
            accountCurrency: 'USD',
            defaultValue: 0.01,
        },
    ],
    [FEATURE_FLAGS.ACCOUNT_VCPM_MAX_VALUE]: [
        {
            accountCurrency: 'USD',
            defaultValue: 30,
        },
    ],
    [FEATURE_FLAGS.ACCOUNT_VCPM_MIN_WARN]: [
        {
            accountCurrency: 'USD',
            defaultValue: 0.05,
        },
    ],
    [FEATURE_FLAGS.ACCOUNT_VCPM_MAX_WARN]: [
        {
            accountCurrency: 'USD',
            defaultValue: 15,
        },
    ],
    [FEATURE_FLAGS.ACCOUNT_CPC_DATA_MIN_VALUE]: [
        {
            accountCurrency: 'USD',
            defaultValue: 0.05,
        },
    ],
    [FEATURE_FLAGS.ACCOUNT_CPC_DATA_MAX_VALUE]: [
        {
            accountCurrency: 'USD',
            defaultValue: Number.POSITIVE_INFINITY,
        },
    ],
    [FEATURE_FLAGS.ACCOUNT_CPM_DATA_MIN_VALUE]: [
        {
            accountCurrency: 'USD',
            defaultValue: 0.1,
        },
    ],
    [FEATURE_FLAGS.ACCOUNT_CPM_DATA_MAX_VALUE]: [
        {
            accountCurrency: 'USD',
            defaultValue: 30,
        },
    ],
    [FEATURE_FLAGS.ACCOUNT_VCPM_DATA_MIN_VALUE]: [
        {
            accountCurrency: 'USD',
            defaultValue: 0.1,
        },
    ],
    [FEATURE_FLAGS.ACCOUNT_VCPM_DATA_MAX_VALUE]: [
        {
            accountCurrency: 'USD',
            defaultValue: 30,
        },
    ],
    [FEATURE_FLAGS.ACCOUNT_BUDGET_LIMITATION_THRESHOLD]: [
        {
            accountCurrency: 'USD',
            defaultValue: 0,
        },
    ],
    [FEATURE_FLAGS.ACCOUNT_BUDGET_MAX_SPENDING_LIMIT]: [
        {
            accountCurrency: 'USD',
            defaultValue: 15000,
        },
    ],
    [FEATURE_FLAGS.ACCOUNT_BUDGET_MIN_SPENDING_LIMIT]: [
        {
            accountCurrency: 'USD',
            defaultValue: 1,
        },
    ],
};

const templateDefaultValues = generateDefaultFlagFromTemplate(configKeyData);

const defaultValues = {
    [FEATURE_FLAGS.IS_CAMPAIGN_COMMENT_SECTION_ENABLED]: 'true',
    [FEATURE_FLAGS.ONBOARDING_ASSISTANT_ENABLED]: 'false',
    [FEATURE_FLAGS.SHOULD_REPORT_LOAD_TIME]: 'true',
    [FEATURE_FLAGS.HAS_OLD_PIXEL]: 'false',
    [FEATURE_FLAGS.HAS_SWITCHED_TO_TABOOLA_PIXEL]: 'false',
    [FEATURE_FLAGS.HAS_CAMPAIGNS]: 'false',
    [FEATURE_FLAGS.HAS_NATIVE_CAMPAIGNS]: 'false',
    [FEATURE_FLAGS.HAS_CAMPAIGNS_VIDEO]: 'false',
    [FEATURE_FLAGS.CAMPAIGNS_BULK_UPDATE_API_ENABLED_KEY]: 'true',
    [FEATURE_FLAGS.ONLY_PERFORMANCE_REPORTS]: 'false',
    [FEATURE_FLAGS.GOOGLE_DRIVE_EXPORT_ENABLED]: 'false',
    [FEATURE_FLAGS.SHOW_CATEGORY_REPORT]: 'true',
    [FEATURE_FLAGS.SHOW_CATEGORY_REPORT_MISSING_DATA_INDICATION]: 'false',
    [FEATURE_FLAGS.CAN_EDIT_CAMPAIGN_USER_SEGMENTS]: 'true',
    [FEATURE_FLAGS.CREATIVE_CREATOR_BULK_CREATE_VARIATIONS_ENABLED]: 'false',
    [FEATURE_FLAGS.CREATIVES_BULK_ACTIONS_ENABLED]: 'true',
    [FEATURE_FLAGS.REPORT_AUTO_FILTERS]: 'true',
    [FEATURE_FLAGS.CREATIVE_DUPLICATE_ENABLED]: 'true',
    [FEATURE_FLAGS.CREATIVE_FORM_DESCRIPTION_ENABLED]: 'false',
    [FEATURE_FLAGS.CREATIVE_ONE_BY_ONE_CREATION_ENABLED]: 'false',
    [FEATURE_FLAGS.BACKSTAGE_ADVERTISER_ENABLE_CTA]: 'false',
    [FEATURE_FLAGS.ACTION_CONVERSION_VIEWS_LOOKBACK_WINDOW]: 30,
    [FEATURE_FLAGS.ACTION_CONVERSION_CLICK_LOOKBACK_WINDOW]: 30,
    [FEATURE_FLAGS.ACTION_CONVERSION_VIEWS_START_DATE]: '9999-12-31 23:59',
    [FEATURE_FLAGS.ACTION_CONVERSION_LAST_CLICK_START_DATE]: '9999-12-31 23:59',
    [FEATURE_FLAGS.FEEDBACK_FORM_IS_VISIBLE]: 'false',
    [FEATURE_FLAGS.CONTACT_SUPPORT_CAN_BE_VISIBLE]: 'false',
    [FEATURE_FLAGS.IS_DUPLICATE_CAMPAIGN_SETTINGS_ENABLED]: 'false',
    [FEATURE_FLAGS.AUDIENCE_BULK_ACTION_ENABLED]: 'false',
    [FEATURE_FLAGS.USE_COUNTRIES_QUERY]: 'false',
    [FEATURE_FLAGS.IS_BUDGET_LIMIT_RATIO_CONFIG]: 'false',
    [FEATURE_FLAGS.BUDGET_LIMIT_RATIO_CONFIG]: '2',
    [FEATURE_FLAGS.IS_CREATIVES_AB_TEST_ENABLED]: 'false',
    [FEATURE_FLAGS.CREATIVES_AB_TEST_MIN_END_DATE_DAYS]: 3,
    [FEATURE_FLAGS.CREATIVES_AB_TEST_MAX_END_DATE_DAYS]: 30,
    [FEATURE_FLAGS.CREATIVES_AB_TEST_DEFAULT_END_DATE_DAYS]: 14,
    [FEATURE_FLAGS.LT_MAX_CPC]: '10',
    [FEATURE_FLAGS.IS_SPECIFIC_LT_MAX_CPC]: 'false',
    [FEATURE_FLAGS.IS_MIN_DAY_PARTING_WINDOW]: 'false',
    [FEATURE_FLAGS.MIN_DAY_PARTING_WINDOW_HRS]: '4',
    [FEATURE_FLAGS.HEAVY_ACCOUNT]: 'false',
    [FEATURE_FLAGS.HEAVY_CREATIVES_REPORT]: 'false',
    [FEATURE_FLAGS.HIDE_HEAVY_ACCOUNT_CREATIVES_REPORT]: 'false',
    [FEATURE_FLAGS.HIDE_HEAVY_ACCOUNT_CAMPAIGNS_REPORT]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_REPORT_TOP_RESULTS_FILTER_ACTIVE]: 'false',
    [FEATURE_FLAGS.SITE_REPORT_TOP_RESULTS_FILTER_ACTIVE]: 'false',
    [FEATURE_FLAGS.CREATIVE_REPORT_TOP_RESULTS_FILTER_ACTIVE]: 'false',
    [FEATURE_FLAGS.LIFETIME_RANGE_PICKER_PRESET_ENABLED]: 'true',
    [FEATURE_FLAGS.PIXEL_PREDICTIVE_ENABLED]: 'false',
    [FEATURE_FLAGS.ENABLE_GROUP_LEADS_GENERATION]: 'false',
    [FEATURE_FLAGS.ENABLE_GROUP_ONLINE_PURCHASES]: 'false',
    [FEATURE_FLAGS.ENABLE_GROUP_DRIVE_WEBSITE_TRAFFIC]: 'false',
    [FEATURE_FLAGS.ENABLE_GROUP_BRAND_AWARENESS]: 'false',
    [FEATURE_FLAGS.ENABLE_GROUP_MOBILE_APP_INSTALL]: 'false',
    [FEATURE_FLAGS.ENABLE_EXTERNAL_APPS_PERMISSIONS]: 'false',
    [FEATURE_FLAGS.THIRD_PARTY_CONNECT_ENABLED]: 'false',
    [FEATURE_FLAGS.MEDIA_LIBRARY_VIDEO_DRAWERS]: 'false',
    [FEATURE_FLAGS.MEDIA_LIBRARY_IMAGE_DRAWERS]: 'false',
    [FEATURE_FLAGS.AI_IMAGE_GENERATION_TAB_ENABLED]: 'false',
    [FEATURE_FLAGS.AI_TITLE_SUGGESTIONS_ENABLED]: 'false',
    [FEATURE_FLAGS.AI_DESCRIPTION_SUGGESTIONS_ENABLED]: 'false',
    [FEATURE_FLAGS.AI_PROMPT_HELPER_ENABLED]: 'false',
    [FEATURE_FLAGS.CHAT_AGENT_FIX_WITH_AI_BUTTON_ENABLED]: 'false',
    [FEATURE_FLAGS.CHAT_AGENT_FIX_WITH_AI_BUTTON_DESCRIPTION_REJECTION_ENABLED]: 'false',
    [FEATURE_FLAGS.CHAT_AGENT_FIX_WITH_AI_BUTTON_MISMATCHED_REJECTION_ENABLED]: 'false',
    [FEATURE_FLAGS.CHAT_AGENT_BUDGET_RECOMMENDATION_ENABLED]: 'false',
    [FEATURE_FLAGS.CHAT_KIT_ENABLED]: 'false',
    [FEATURE_FLAGS.APPLE_SECOND_REVIEW_AUTO_APPROVED]: 'false',
    [FEATURE_FLAGS.CREATIVE_REPORT_HIDDEN_CRA_TAG_COMMENTS_LIST]: '',
    [FEATURE_FLAGS.CREATIVE_REPORT_CRA_TAG_TOOLTIP_IGNORE_DSP]: 'false',
    [FEATURE_FLAGS.CREATIVE_CREATOR_SHOULD_SHOW_DISPLAY_AD_TYPE]: 'true',
    [FEATURE_FLAGS.CREATIVE_CREATOR_SHOULD_SHOW_DIMENSIONS_INFO]: 'true',
    [FEATURE_FLAGS.TAG_TYPE_IAS_ENABLED]: 'true',
    [FEATURE_FLAGS.TAG_TYPE_ADLOOX_ENABLED]: 'true',
    [FEATURE_FLAGS.TAG_TYPE_DV_ENABLED]: 'true',
    [FEATURE_FLAGS.TAG_TYPE_GOOGLE_DCM_ENABLED]: 'true',
    [FEATURE_FLAGS.TAG_TYPE_IMAGE_PIXEL_ENABLED]: 'true',
    [FEATURE_FLAGS.PROGRAMMATIC_BUDGET_ENABLED]: 'false',
    [FEATURE_FLAGS.ENABLE_DEAL_ID]: 'false',
    [FEATURE_FLAGS.SHOULD_DISPLAY_LEGACY_CATEGORY_FILTER]: 'true',
    [FEATURE_FLAGS.SHOULD_DISPLAY_IAB_CATEGORY_FILTER]: 'false',
    [FEATURE_FLAGS.TARGET_CPA_ENABLED]: 'false',
    [FEATURE_FLAGS.TARGET_CPA_NO_CPC_ENABLED]: 'false',
    [FEATURE_FLAGS.TARGET_CPA_DUPLICATE_CAMPAIGN_ENABLED]: 'false',
    [FEATURE_FLAGS.ENABLE_CREATIVE_TRACKING]: 'false',
    [FEATURE_FLAGS.HYBRID_MODULE_QUERY_PARAMS_ENABLED]: 'true',
    [FEATURE_FLAGS.HYBRID_MODULE_HEADER_PARAMS_ENABLED]: 'false',
    [FEATURE_FLAGS.TARGET_ROAS_ENABLED]: 'false',
    [FEATURE_FLAGS.MAX_VALUE_ENABLED]: 'false',
    [FEATURE_FLAGS.SUPPLY_EXPLORATION_ENABLED]: 'false',
    [FEATURE_FLAGS.SAFETY_NETS_ENABLED_CONFIG_ATTRIBUTE]: 'true',
    [FEATURE_FLAGS.IS_DCO_ACCOUNT]: 'false',
    [FEATURE_FLAGS.BILLING_AND_PAYMENTS_MODULE_ENABLED]: 'false',
    [FEATURE_FLAGS.SHOULD_HIDE_CURRENT_BALANCE]: 'false',
    [FEATURE_FLAGS.CREATIVE_RESUBMISSION_ENABLED]: 'false',
    [FEATURE_FLAGS.MIN_CONVERSIONS_GOAL_ENABLED]: 'false',
    [FEATURE_FLAGS.CREATIVE_EDIT_VIDEO_DUPLICATE_ENABLED]: 'false',
    [FEATURE_FLAGS.CREATIVE_FORM_CTA_ENABLED]: 'false',
    [FEATURE_FLAGS.CTA_TRANSLATIONS_ENABLED]: 'true',
    [FEATURE_FLAGS.ADS_REPORT_VIDEO_ON_HOVER_ENABLED]: 'false',
    [FEATURE_FLAGS.IMPRESSION_TYPE_FIELD]: null,
    [FEATURE_FLAGS.CREATE_LOOKALIKE_ALLOWED]: 'false',
    [FEATURE_FLAGS.CREATE_LOOKALIKE_ALLOWED_NEW]: 'false',
    [FEATURE_FLAGS.ADS_CONSOLE_CUSTOM_CONTEXTUAL_ALLOWED]: 'false',
    [FEATURE_FLAGS.ADS_CONSOLE_COMBINED_AUDIENCES_ALLOWED]: 'false',
    [FEATURE_FLAGS.ADS_CONSOLE_YAHOO_AUDIENCES_ALLOWED]: 'false',
    [FEATURE_FLAGS.ADS_CONSOLE_YAHOO_AUDIENCES_KEYWORD_SUGGESTIONS_ALLOWED]: 'false',
    [FEATURE_FLAGS.ADS_CONSOLE_YAHOO_AUDIENCES_SUGGESTIONS_AND_CATEGORIES_ALLOWED]: 'false',
    [FEATURE_FLAGS.SUPPLY_TARGETING_USE_YAHOO_MOMENTS_SLIDER_ENABLED]: 'false',
    [FEATURE_FLAGS.ADS_CONSOLE_REACH_ESTIMATOR_ALLOWED]: 'false',
    [FEATURE_FLAGS.ADS_CONSOLE_REACH_ESTIMATOR_BID_ALLOWED]: 'false',
    [FEATURE_FLAGS.ADS_CONSOLE_CUSTOM_CONTEXTUAL_ARTICLES_PREVIEW_ALLOWED]: 'false',
    [FEATURE_FLAGS.CREATE_CUSTOMER_FILE_ALLOWED]: 'false',
    [FEATURE_FLAGS.TARGET_CPA_ELIGIBLE_ACCOUNTS]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_LEVEL_CONVERSIONS_BID_STRATEGY_ALLOW_TARGET_CPA]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_LEVEL_CONVERSIONS_BID_STRATEGY_ALLOW_MAX_CONVERSIONS]: 'false',
    [FEATURE_FLAGS.BLOCK_INSIGNICANT_CREATIVE_CHANGES_ENABLED]: 'true',
    [FEATURE_FLAGS.SHOW_OUTDATED_API_NOTICE]: 'false',
    [FEATURE_FLAGS.NOTIFICATIONS_CENTER_ENABLED]: 'false',
    [FEATURE_FLAGS.NOTIFICATIONS_CENTER_ONLY_FOR_LOW_TOUCH]: 'true',
    [FEATURE_FLAGS.MY_AUDIENCE_DROPDOWN_IS_DISABLEABLE]: 'false',
    [FEATURE_FLAGS.MY_AUDIENCES_FILTERS_ENABLED]: 'false',
    [FEATURE_FLAGS.WOCHIT_CREATE_VIDEO_ENABLED]: 'true',
    [FEATURE_FLAGS.SHOW_CAMPAIGN_HISTORY_REPORT]: 'true',
    [FEATURE_FLAGS.SHOW_CAMPAIGN_HISTORY_REPORT_GRAPH]: 'true',
    [FEATURE_FLAGS.ENABLE_RIBBON_RECOMMENDATION]: 'false',
    [FEATURE_FLAGS.SUBMISSION_DATA_ALLOWED_IN_ADS_REPORT]: 'false',
    [FEATURE_FLAGS.AUDIENCE_TARGETING_FIRST_CAMPAIGN_MESSAGE_ENABLED]: 'false',
    [FEATURE_FLAGS.IS_WITH_TAX_REGISTRATION]: 'false',
    [FEATURE_FLAGS.IS_WITH_VAT_ID]: 'false',
    [FEATURE_FLAGS.SHOW_COMPARE_CAMPAIGNS_GRAPH]: 'false',
    [FEATURE_FLAGS.SHOW_COMPARE_CREATIVES_GRAPH]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_LEVEL_CONVERSIONS]: 'false',
    [FEATURE_FLAGS.TA_REALTIME]: 'false',
    [FEATURE_FLAGS.IS_SCHEDULE_TRACKING_EXPERT_ENABLED_TA]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_PERFORMANCE_RULES_ENABLED]: 'false',
    [FEATURE_FLAGS.AUTO_REVIEWER_CONTENT_VALIDATIONS_ENABLED]: 'false',
    [FEATURE_FLAGS.IS_PIXEL_CODE_ENABLED]: 'false',
    [FEATURE_FLAGS.TRACKING_SCREENS]: 'true',
    [FEATURE_FLAGS.GTM_AUTOMATED_SETUP_ENABLED]: 'false',
    [FEATURE_FLAGS.CONVERSION_AGGREGATED_TYPE_ENABLED]: 'false',
    [FEATURE_FLAGS.CONVERSION_FUNNEL_ENABLED]: 'false',
    [FEATURE_FLAGS.CONVERSION_DEFAULT_FUNNEL_ENABLED]: 'false',
    [FEATURE_FLAGS.CVR_LEARNING_STATUS_ENABLED]: 'true',
    [FEATURE_FLAGS.PERFORMANCE_RULES_ENABLED]: 'false',
    [FEATURE_FLAGS.PERFORMANCE_RULES_EXECUTED_ACTIONS_ENABLED]: 'false',
    [FEATURE_FLAGS.EDIT_PERFORMANCE_RULES_ENABLED]: 'false',
    [FEATURE_FLAGS.DUPLICATE_PERFORMANCE_RULES_ENABLED]: 'false',
    [FEATURE_FLAGS.PERFORMANCE_RULES_PREVIEW_ENABLED]: 'false',
    [FEATURE_FLAGS.PERFORMANCE_RULES_REPORTS_ENABLED]: 'false',
    [FEATURE_FLAGS.PERFORMANCE_RULES_LONG_LOOK_BACK_WINDOW_ENABLED]: 'false',
    [FEATURE_FLAGS.PERFORMANCE_RULES_UNDO_ACTIONS_ENABLED]: 'false',
    [FEATURE_FLAGS.PERFORMANCE_RULES_ENABLE_EMAIL_NOTIFICATIONS]: 'false',
    [FEATURE_FLAGS.PERFORMANCE_RULES_ENABLE_CAMPAIGN_DIMENSION]: 'false',
    [FEATURE_FLAGS.PERFORMANCE_RULES_ENABLE_LEAVE_AN_ACTIVE_ITEM]: 'false',
    [FEATURE_FLAGS.PERFORMANCE_RULES_TIME_WINDOW_OFFSET_ENABLED]: 'true',
    [FEATURE_FLAGS.DCO_ACCOUNT_HAS_IN_TRIAL_CAMPAIGNS]: 'false',
    [FEATURE_FLAGS.CROPPING_IMAGE_ENABLED]: 'false',
    [FEATURE_FLAGS.OUTCROPPING_IMAGE_ENABLED]: 'false',
    [FEATURE_FLAGS.RANGE_OF_RATIO_OUTCROPPING_ENABLED]: 'false',
    [FEATURE_FLAGS.CREATIVE_REPORT_USE_WIDE_CONFIG_MSV2]: 'false',
    [FEATURE_FLAGS.MARKETPLACE_AUDIENCES_BUNDLING_ENABLED]: 'false',
    [FEATURE_FLAGS.DEMOGRAPHICS_AUDIENCES_REPORT_ENABLED]: 'false',
    [FEATURE_FLAGS.MARKETPLACE_AUDIENCES_AND_LOGIC_ENABLED]: 'false',
    [FEATURE_FLAGS.MARKETPLACE_AUDIENCES_AGE_GROUP_IDS_LIST]: '',
    [FEATURE_FLAGS.MARKETPLACE_AUDIENCES_GENDER_GROUP_IDS_LIST]: '',
    [FEATURE_FLAGS.MARKETPLACE_AUDIENCES_AGE_GROUP_TAXONOMY_PARENTS_LIST]: '',
    [FEATURE_FLAGS.MARKETPLACE_AUDIENCES_GENDER_GROUP_TAXONOMY_PARENTS_LIST]: '',
    [FEATURE_FLAGS.MARKETPLACE_AUDIENCES_AGE_SEGMENT_LIMIT]: '1',
    [FEATURE_FLAGS.MARKETPLACE_AUDIENCES_GENDER_SEGMENT_LIMIT]: '1',
    [FEATURE_FLAGS.MARKETPLACE_AUDIENCES_MIXED_SEGMENT_LIMIT]: '2',
    [FEATURE_FLAGS.MARKETPLACE_AUDIENCES_ADVANCED_SEARCH_ENABLED]: 'false',
    [FEATURE_FLAGS.BID_STRATEGY_V2_ENABLED]: 'false',
    [FEATURE_FLAGS.MAX_CONVERSIONS_ENABLED]: 'false',
    [FEATURE_FLAGS.CREATIVE_CREATION_AI_VARIATIONS_ENABLED]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_GROUP_ENABLED]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_GROUP_IS_MANDATORY]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_GROUP_EXTENSION_ENABLED]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_GROUP_BUDGET_DISTRIBUTION_ENABLED]: 'false',
    [FEATURE_FLAGS.PACE_AHEAD_ENABLED]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_GROUP_PACE_AHEAD_ENABLED]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_MULTIPLE_CONVERSIONS_ENABLED]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_NON_OPTIMIZED_CONVERSIONS_ENABLED]: 'false',
    [FEATURE_FLAGS.HIDE_CONVERSIONS_GOAL_ACCOUNT_DEFAULT]: 'false',
    [FEATURE_FLAGS.BID_DAY_TIME_ENABLED]: 'false',
    [FEATURE_FLAGS.TIME_ZONE_ENABLED]: 'true',
    [FEATURE_FLAGS.USER_TIME_ZONE_ENABLED]: 'false',
    [FEATURE_FLAGS.SCHEDULE_DAY_TIME_ENABLED]: 'false',
    [FEATURE_FLAGS.BID_PLATFORM_ENABLED]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_CONVERSION_CONFIGURATION_ENABLED]: 'false',
    [FEATURE_FLAGS.MAX_EXCLUDE_COUNTRIES]: 200,
    [FEATURE_FLAGS.AI_WIZARD_ONBOARDING]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_REPORT_USE_WIDE_CONFIG_MSV2]: 'false',
    [FEATURE_FLAGS.HIDE_HEAVY_ACCOUNT_HIDE_CAMPAIGNS_REPORT_FILTERS]: 'false',
    [FEATURE_FLAGS.SITE_REPORT_USE_WIDE_CONFIG_MSV2]: 'false',
    [FEATURE_FLAGS.SITE_REPORT_DONT_USE_WIDE_CONFIG_MSV2]: 'false',
    [FEATURE_FLAGS.FAVORITED_MEDIA_ENABLED]: 'false',
    [FEATURE_FLAGS.SUPPLY_TARGETING_ENABLED]: 'false',
    [FEATURE_FLAGS.SUPPLY_TARGETING_SLIDER_ENABLED]: 'false',
    [FEATURE_FLAGS.REACH_ESTIMATOR_SUPPLY_TARGETING_AND_SITE_TARGETING_WARNING]: 'false',
    [FEATURE_FLAGS.SUPPLY_TARGETING_USE_TABOOLA_VALUE_AS_DEFAULT]: 'false',
    [FEATURE_FLAGS.LOW_TIER_DAILY_LIMIT_MAX_VALUE]: null,
    [FEATURE_FLAGS.TA_PIXEL_WARNINGS_TESTING]: 'false',
    [FEATURE_FLAGS.PROFIT_MARGIN_ENABLED]: 'false',
    [FEATURE_FLAGS.SHOULD_DISPLAY_JS_FOR_ALL]: 'true',
    [FEATURE_FLAGS.DISABLED_CLC_THRESHOLD_WARNING]: 'false',
    [FEATURE_FLAGS.REPLACE_IMAGE_BACKGROUND]: 'false',
    [FEATURE_FLAGS.REPLACE_IMAGE_BACKGROUND_SEGMENT_ANYTHING]: 'false',
    [FEATURE_FLAGS.REPLACE_IMAGE_BACKGROUND_SEGMENT_ANYTHING_POPUP]: 'true',
    [FEATURE_FLAGS.CREATIVE_STUDIO_GENERATE_VARIATIONS]: 'false',
    [FEATURE_FLAGS.GEN_AI_EDIT_DUPLICATE_TOOLTIP_ENABLED]: 'false',
    [FEATURE_FLAGS.SUPPORT_APP_INSTALL_MULTI_SLOTS_WIDGETS]: 'false',
    [FEATURE_FLAGS.AI_VARIATIONS_REPLACEMENT_ENABLED]: 'true',
    [FEATURE_FLAGS.SHOW_CAMPAIGN_GROUP_PICKER_IN_IFRAME]: 'true',
    [FEATURE_FLAGS.ACCOUNT_REPORT_ENABLED]: 'true',
    [FEATURE_FLAGS.ONLINE_PURCHASES_MARKETING_OBJECTIVE_ENABLED]: 'true',
    [FEATURE_FLAGS.CAMPAIGN_BULK_UPLOAD]: 'false',
    [FEATURE_FLAGS.BULK_OPERATIONS_METADATA_CHECK_DISABLED]: 'false',
    [FEATURE_FLAGS.ALLOW_SEARCH_ADS_REPORTS]: 'false',
    [FEATURE_FLAGS.CREATIVE_CAROUSEL_ENABLED]: 'false',
    [FEATURE_FLAGS.IS_VERTICAL_CREATIVE_ENABLED]: 'false',
    [FEATURE_FLAGS.GEN_AI_AB_TEST_WITH_AI]: 'true',
    [FEATURE_FLAGS.GEN_AI_OPTIMIZATION_PREVIEWS_DRAWER_ENABLED]: 'false',
    [FEATURE_FLAGS.LLM_DKI_DETECTION_ENABLED]: 'false',
    [FEATURE_FLAGS.UNLIMITED_BUDGET_ENABLED]: 'false',
    [FEATURE_FLAGS.SHOW_LEGACY_CATEGORY_FILTER]: 'false',
    [FEATURE_FLAGS.IS_BILLING_RECONCILIATION_V2_ENABLED]: 'false',
    [FEATURE_FLAGS.ENABLE_READ_FOR_STRIPE_CARD_3DS]: 'false',
    [FEATURE_FLAGS.SHOW_INTERNAL_LINK_CUSTOM_CONTEXT_MENU]: 'false',
    [FEATURE_FLAGS.DROPDOWN_EDIT_FALLBACK_IMAGE_OPTION_ENABLED]: 'false',
    [FEATURE_FLAGS.SHOW_CUSTOM_DATA_IN_CREATIVE_FORM]: 'false',
    [FEATURE_FLAGS.SHOULD_SHOW_DISPLAY_DATA]: 'false',
    [FEATURE_FLAGS.ACCOUNT_MANAGEMENT_ENABLED]: 'false',
    [FEATURE_FLAGS.REALIZE_HOME_ENABLED]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_EXTERNAL_METADATA_ENABLED]: 'false',
    [FEATURE_FLAGS.BULK_URL_VALIDATION_ENABLED]: 'true',
    [FEATURE_FLAGS.HIDE_ADMIN_ACCOUNT_SITE_REPORT]: 'false',
    [FEATURE_FLAGS.SHOW_PO_NUMBER]: 'false',
    [FEATURE_FLAGS.EXTERNAL_DATA_DELETION_DISABLED]: 'false',
    [FEATURE_FLAGS.EXTERNAL_DATA_READONLY_FIELDS]: '',
    [FEATURE_FLAGS.CAMPAIGN_EXTERNAL_DATA_DELETION_DISABLED]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_EXTERNAL_DATA_READONLY_FIELDS]: '',
    [FEATURE_FLAGS.SCHEDULED_REPORTS_VIEW]: 'false',
    [FEATURE_FLAGS.SCHEDULED_REPORTS_EDIT]: 'false',
    [FEATURE_FLAGS.SCHEDULED_REPORTS_EDIT_VIEW_ON_NETWORK]: 'false',
    [FEATURE_FLAGS.SCHEDULED_REPORTS_ACCOUNT_SELECT_ON_NETWORK_LEVEL]: 'false',
    [FEATURE_FLAGS.SCHEDULED_REPORTS_CAMPAIGN_GROUP_REPORT_ENABLED]: 'false',
    [FEATURE_FLAGS.SCHEDULED_REPORTS_CUSTOM_RULE_REPORT_ENABLED]: 'false',
    [FEATURE_FLAGS.PROFIT_MARGIN_IN_REPORT_ENABLED]: 'false',
    [FEATURE_FLAGS.VTA_LOOKBACK_WINDOW_INITIAL_VALUE_IN_HOURS]: 24,
    [FEATURE_FLAGS.VTA_LOOKBACK_WINDOW_MAX_VALUE_IN_HOURS]: 168,
    [FEATURE_FLAGS.VTA_LOOKBACK_WINDOW_DEFAULT_VALUE_IN_DAYS]: 'false',
    [FEATURE_FLAGS.TABOOLA_SELECT_ENABLED]: 'false',
    [FEATURE_FLAGS.SUPPORT_BP_ASPECT_RATIOS]: 'false',
    [FEATURE_FLAGS.SUPPLY_TARGETING_PMP_ENABLED]: 'false',
    [FEATURE_FLAGS.EXCEL_BULK_ALLOW_FULL_CONFIG]: 'false',
    [FEATURE_FLAGS.UNIFIED_CREATIVE_ENDPOINTS_ENABLED]: 'false',
    [FEATURE_FLAGS.VENDOR_MACRO_REPLACEMENT_ENABLED]: 'false',
    [FEATURE_FLAGS.MAX_CONVERSIONS_CPC_CAP_ENABLED_FOR_PUBLISHER]: 'false',
    [FEATURE_FLAGS.ENABLE_YAHOO_APP_HEADER_STYLE]: 'false',
    [FEATURE_FLAGS.SHOW_ESTIMATED_DAILY_CAP_COLUMN_REPORTS]: 'false',
    [FEATURE_FLAGS.ONBOARDING_JOURNEY_ENABLED]: 'false',
    [FEATURE_FLAGS.MULTI_LAYER_DRAWER_ENABLED]: 'false',
    [FEATURE_FLAGS.IS_TCPA_PIXEL_VALIDATION_ENABLED]: 'false',
    [FEATURE_FLAGS.PERFORMANCE_RULES_ENABLE_EXCLUDE_NEW_CAMPAIGNS]: 'false',
    [FEATURE_FLAGS.SHOW_SHOPIFY_SETUP]: 'false',
    [FEATURE_FLAGS.SENSITIVE_TOPICS_BRAND_SAFETY_ENABLED]: 'false',
    [FEATURE_FLAGS.CAMPAIGNS_GROUP_BULK_ACTIONS_ENABLED]: 'false',
    [FEATURE_FLAGS.DISABLE_CREATE_BUTTON]: 'false',
    [FEATURE_FLAGS.EXCEL_BULK_UPLOAD_ADS_ONLY]: 'false',
    [FEATURE_FLAGS.THUMBNAIL_TRANSFORMATION_PADDING]: null,
    [FEATURE_FLAGS.BID_MODIFICATION_DAY_TIME_BOOST_MAX_DEFAULT]: 2,
    [FEATURE_FLAGS.CAMPAIGN_SIMULATOR_ENABLED]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_SIMULATOR_CHECK_PERMISSION_ENABLED]: 'true',
    [FEATURE_FLAGS.CAMPAIGN_SIMULATOR_BUTTON_ENABLED]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_SIMULATOR_WEEKLY_ENABLED]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_SIMULATOR_BOUNDS_VISUALIZATION_ENABLED]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_BULK_EDIT_ENABLED]: 'false',
    [FEATURE_FLAGS.ENGAGEMENT_CREATE_ENABLED]: 'false',
    [FEATURE_FLAGS.IS_DISPLAY_FILTERS_ENABLED]: 'false',
    [FEATURE_FLAGS.MAX_TOTAL_RECORDS_FOR_REPORT_EXPORT]: 50000,
    [FEATURE_FLAGS.MAX_TOTAL_RECORDS_FOR_DYNAMIC_REPORT_EXPORT]: 50000,
    [FEATURE_FLAGS.DYNAMIC_REPORTS_ENABLED]: 'false',
    [FEATURE_FLAGS.DYNAMIC_REPORTS_TODAY_PRESET_ENABLED]: 'false',
    [FEATURE_FLAGS.CODELESS_CONVERSIONS_ENABLED]: 'true',
    [FEATURE_FLAGS.PIXEL_TESTER_ENABLED]: 'false',
    [FEATURE_FLAGS.PIXEL_TESTER_S2S_ENABLED]: 'false',
    [FEATURE_FLAGS.PIXEL_TESTER_USER_MATCHING_ENABLED]: 'false',
    [FEATURE_FLAGS.DISPLAY_IMPORT_FROM_SOCIAL_ENABLED]: 'false',
    [FEATURE_FLAGS.IS_DISPLAY_AD_TAG_SERVICE_ENABLED]: 'false',
    [FEATURE_FLAGS.FREQUENCY_CAPPING_ENABLED_CONFIG_ATTRIBUTE]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_GROUP_PICKER_ENABLED]: 'false',
    [FEATURE_FLAGS.SCROLL_DEPTH_ENABLED]: 'false',
    [FEATURE_FLAGS.CODELESS_TFA_VALIDATION_ENABLED]: 'false',
    [FEATURE_FLAGS.CODELESS_VALUE_ENABLED]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_GROUP_DUPLICATE_ENABLED]: 'false',
    [FEATURE_FLAGS.CREATE_PBP_EXCLUDED_CUSTOMER_PROFILES_LIST]:
        'Search - RSoC,Search - Traditional,Performance Publisher,Arbitrage',
    [FEATURE_FLAGS.NEW_EXPORT]: 'false',
    [FEATURE_FLAGS.DYNAMIC_REPORT_ASYNC_EXPORT]: 'false',
    [FEATURE_FLAGS.ADS_CONSOLE_BLOCK_PREDICTIVE_AUDIENCES_IN_EDIT_CAMPAIGN]: 'false',
    [FEATURE_FLAGS.ADS_CONSOLE_PREVENT_PBP_NON_PBP_AUDIENCE_TYPE_MIXING_IN_EDIT_CAMPAIGN]: 'false',
    [FEATURE_FLAGS.CREATE_IMAGE_TO_MOTION_ENABLED]: 'false',
    [FEATURE_FLAGS.IMAGE_TO_MOTION_PARAMS_ENABLED]: 'false',
    [FEATURE_FLAGS.ENABLE_CREATIVE_BULK_EDIT_AD_SCHEDULE]: 'false',
    [FEATURE_FLAGS.DYNAMIC_REPORTS_METAMODEL_EXCLUDE_NODE_LIST]:
        'PERFORMANCE_REPORT-TARGETING-SITE-NAME,PERFORMANCE_REPORT-TARGETING-PLATFORM-CODE',
    [FEATURE_FLAGS.CREATIVE_LIBRARY_ENABLED]: 'false',
    [FEATURE_FLAGS.CREATIVE_LIBRARY_BULK_EXCEL_ENABLED]: 'false',
    [FEATURE_FLAGS.CREATE_IMAGE_TO_MOTION_ENABLED]: 'false',
    [FEATURE_FLAGS.INVENTORY_TYPE_TARGETING_ENABLED]: 'false',
    [FEATURE_FLAGS.GEN_AI_LANDING_PAGES_MODULE_ENABLED]: 'false',
    [FEATURE_FLAGS.CAROUSEL_ALLOW_HIERARCHY_FALLBACK]: 'false',
    [FEATURE_FLAGS.AUDIENCE_LAST_REFRESHED_ENABLED]: 'false',
    [FEATURE_FLAGS.DUPLICATE_CAMPAIGNS_COPIES_FIELD_ENABLED]: 'false',
    [FEATURE_FLAGS.CHANGE_CAMPAIGN_GROUP_START_DATE_ENABLED]: 'false',
    [FEATURE_FLAGS.CODELESS_CONTINUE_ANYWAY_ENABLED]: 'false',
    [FEATURE_FLAGS.CODELESS_LOG_ROCKET_ENABLED]: 'false',
    [FEATURE_FLAGS.ADS_CONSOLE_CAMPAIGN_GROUP_GOAL_ROLLOUT]: 'false',
    [FEATURE_FLAGS.EVENT_MANAGER_ENABLED]: 'false',
    [FEATURE_FLAGS.SHOULD_STOP_USING_REPORT_HISTORICAL_DATA]: 'false',
    [FEATURE_FLAGS.MAX_DATE_RANGE_LENGTH_MONTH]: 12,
    [FEATURE_FLAGS.IS_MANDATORY_HIERARCHY_ENABLED]: 'false',
    [FEATURE_FLAGS.CAMPAIGN_GROUP_BUDGET_UNLIMITED_AS_NONE_ENABLED]: 'false',
    [FEATURE_FLAGS.BID_MODIFIER_BULK_EDIT_ENABLED]: 'false',
    [FEATURE_FLAGS.BULK_EDIT_UNSAVED_CHANGES_ENABLED]: 'false',
    [FEATURE_FLAGS.IS_DEFAULT_TRACKING_CODE_EMPTY]: 'false',
    [FEATURE_FLAGS.VTA_LOOKBACK_WINDOW_CHECKBOX_ENABLED]: 'false',
    [FEATURE_FLAGS.IS_BID_MODIFICATION_ON_VIDEO_SITE_REPORT_ENABLED]: 'true',
    ...templateDefaultValues,
};
export { FEATURE_FLAGS, defaultValues, fallbackPolicies };
